<template>
  <div class="servicePerformance">
    <a-row v-if="sites.length" :gutter="16" style="margin: 0 1px">
      <a-col
        v-for="(site, index) in sites"
        :key="site.id"
        :sm="24"
        :xl="12"
        style="margin-bottom: 16px"
      >
        <div v-if="sitesStatistic[index]" class="service-performance-container">
          <a
            @click="$refs.performanceMoreModal.show(service, site)"
            class="container-header-btn"
          >
            更多>>
          </a>
          <div class="module-header" style="margin-bottom: 8px">
            {{ site.name }}
          </div>

           <a-col
            :span="11"
            class="container-context container-context-left"
          >
            <div class="context-title">平均响应成功率</div>
            <performance-left-chart
              :chartId="`performance-left-chart-${site.id}`"
              :chartData="sitesStatistic[index].requestRate"
            ></performance-left-chart>
            <div class="context-tooltip-container">
              <div>
                <a-icon type="check-circle" />
                响应成功：{{ sitesStatistic[index].requestsSuccess }} 次
              </div>
              <div>
                <a-icon type="close-circle" />
                响应失败：{{ sitesStatistic[index].requestsFailed }} 次
              </div>
            </div>
          </a-col>
          <a-col
            :span="13"
            class="container-context container-context-right"
          >
            <div class="context-title">请求统计</div>
            <div class="count-container">
              <div style="margin-right: 24px">
                <p>请求数</p>
                <p>{{ sitesStatistic[index].requests }}</p>
              </div>
              <div>
                <p>P95</p>
                <p>{{ sitesStatistic[index]['95th_request_time'] }}</p>
              </div>
            </div>
            <performance-right-chart
              :serviceId="serviceId"
              :currentChartId="`performance-current-chart-${index}`"
              :compareChartId="`performance-compare-chart-${index}`"
              @rate="
                v => {
                  if (v >= 0) {
                    requestCompareCount = v
                  } else {
                    isNegativeNumber = true
                    requestCompareCount = v.toString().split('-')[1]
                  }
                }
              "
              :site="site"
            ></performance-right-chart>
          </a-col>
        </div>
      </a-col>
    </a-row>

    <empty-component
      v-else
      :imgUrl="require('@/assets/images/info_empty.png')"
      :body-style="{
        height: '216px',
        marginTop: '0px'
      }"
      :description-style="{
        marginTop: '-32px',
        marginRight: '8px'
      }"
      description="暂无数据"
      style="margin-top: 12vh"
    ></empty-component>

    <performance-more-modal ref="performanceMoreModal"></performance-more-modal>
  </div>
</template>

<script>
import {
  getServiceSiteList
} from '@/api/service'
import { getSiteStatistic } from '@/api/site.js'
import PerformanceLeftChart from './modules/PerformanceLeftChart'
import PerformanceRightChart from './modules/PerformanceRightChart'
import PerformanceMoreModal from './modules/PerformanceMoreModal.vue'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'ServicePerformance',
  components: {
    PerformanceLeftChart,
    PerformanceRightChart,
    PerformanceMoreModal,
    EmptyComponent
  },
  props: {
    serviceId: {
      type: String
    },
    service: {
      type: Object
    }
  },
  data () {
    return {
      requestCompareCount: 0,
      sites: [],
      isNegativeNumber: false,
      sitesStatistic: []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.sites = []
      getServiceSiteList(this.serviceId).then(res => {
        this.sites = res.data ? res.data.data : []
        if (this.sites.length) {
          const sitesStatistic = []
          for (let i = 0; i < this.sites.length; i++) {
            getSiteStatistic(this.sites[i].id).then(v => {
              const data = v.data
              const obj = {
                requests: data.requests,
                requestsFailed: data.requests_failed,
                requestsSuccess: data.requests - data.requests_failed,
                requestRate: [{ value: 0 }]
              }
              if (data.requests === 0) obj.requestRate = [{ value: 0 }]
              else obj.requestRate = [{ value: (obj.requestsSuccess / obj.requests * 100).toFixed(2) * 1 }]
              obj['95th_request_time'] = data['95th_request_time']
              sitesStatistic.push(obj)
            })
          }
          this.sitesStatistic = sitesStatistic
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.servicePerformance {
   .service-performance-container {
    height: 338px;
    position: relative;
    background: #fff;
    border-radius: 6px;
    padding: 16px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;

    .container-header-btn {
      position: absolute;
      top: 20px;
      right: 18px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #096dd9;
      line-height: 17px;
      z-index: 999;
    }

    .container-context {
      .context-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: rgba(0, 0, 0, 0.75);
        line-height: 20px;
      }
      .context-tooltip-container {
        height: 20px;
        display: flex;
        justify-content: space-evenly;
        padding-right: 20px;
        flex-wrap: wrap;

        div {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 17px;

          i {
            margin-right: 5px;
            color: #5ac725;
          }

          &:nth-of-type(2) {
            i {
              color: #ff4d4f;
            }
          }
        }
      }
    }
    .container-context-left {
      border-right: 1px solid #e0e0e0;
      padding-left: 16px !important;
    }
    .container-context-right {
      padding-left: 40px !important;

      .count-container {
        overflow: hidden;
        margin-top: 9px;
        p {
          margin: 0;
        }

        & > div {
          float: left;
          height: 64px;
          border-radius: 8px;
          border: 1px solid #c6ddf6;
          padding: 9px 16px 8px 12px;
          min-width: 90px;

          p {
            &:nth-of-type(1) {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 17px;
            }

            &:nth-of-type(2) {
              font-size: 22px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #096dd9;
              line-height: 30px;
            }
          }
          .red-color {
            color: #ff4d4f !important;
          }
          .green-color {
            color: #52c41a !important;
          }
        }

        & > div.green-border-color {
          border-color: #52c41a !important;
        }
      }
    }
  }
}
</style>
